import React, {useEffect, useState} from "react";
import {newPurchase} from "@/api/purchase";
import globalStyle from '@/styles/Global.scss'
import FormSubmitButton from '@/components/atom/FormSubmitButton'

const [ paygentEndPoint, webEndPoint  ] = [ process.env.REACT_APP_PAYGENT_END_POINT, process.env.REACT_APP_WEB_ENDPOINT ]

export const PaygentForm = ({ price = 500, cardId, buttonText = 'お支払い', item = 'subscription' }) => {
  const [paygentForm, setPaygentForm] = useState()
  const [returnUrl, setReturnUrl] = useState()
  const debug = false

  useEffect(() => {
    (async () => {
      if (cardId === undefined) {
        return
      }
      const paygentForm = await newPurchase({ price, cardId, item })
      setPaygentForm(paygentForm)
      setReturnUrl(`${webEndPoint}/watashi/${cardId}`)
    })()
  }, [price, cardId, item])

  return (
    <>
      {
        paygentForm &&
        <form method="post" action={paygentEndPoint}>
          { debug &&
            <>
              <div>echo -n "{ paygentForm.tradingId }02{ price }{ paygentForm.merchantId }usz5NB8uX9" | openssl dgst -sha256 | pbcopy</div>
              <div>{ paygentForm.tradingId }</div>
              <div>{ '02' }</div>
              <div>{ price }</div>
              <div>{ paygentForm.merchantId }</div>
              <div>{ paygentForm.hash }</div>
            </>
          }
          <input type="hidden" name="trading_id" value={paygentForm.tradingId} />
          <input type="hidden" name="payment_type" value="02" />
          <input type="hidden" name="id" value={price} />
          <input type="hidden" name="seq_merchant_id" value={paygentForm.merchantId} />
          <input type="hidden" name="hc" value={paygentForm.hash} />
          { returnUrl && <input type="hidden" name="return_url" value={returnUrl} /> }
          <FormSubmitButton image={'oshiharai.png'} className={globalStyle.navigateButton}>お支払い</FormSubmitButton>
        </form>
      }
    </>
  )
}
